export default {
  BLUE_BELL: "#A299D4",
  BLUE_CHALK: "#ECEAF6",
  BLUE_MARGUERITE: "#514D9D",
  CORNFLOWER_BLUE: "#628EFF",
  DARK_BURGUNDY: "#7B0404",
  DARK_INDIGO: "#130159",
  HIT_PINK: "#F8AA7E",
  IRON: "#D9D6ED",
  LAVANDER_PINOCCHIO: "#f6f4ff",
  LINEN: "#ffecdfff",
  SALMON: "#FF795C",
  SUNDOWN: "#FFB3B3",
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  LIGHT_WISTERIA: "#E7E5F5",
  CONTAINER_BACKGROUND: "#F5F4FA",
  FILTER_COLOR: "#5F4DC7",
  BOX_SHADOW_BLACK: "#0000001F",
};
